import { Record, Map as ImmutableMap, fromJS } from 'immutable';
import TimeDelay from 'automation-ui-flow-core/fields/time/TimeDelay';
import * as PropertyValueTypes from 'automation-ui-flow-core/fields/PropertyValueTypes';
import FieldDataIdentifier from 'automation-ui-flow-core/fields/FieldDataIdentifier';
export default class PropertyValue extends Record({
  type: PropertyValueTypes.STATIC_VALUE,
  value: '',
  propertyName: null,
  propertyToken: null,
  timeDelay: null,
  amount: 0,
  identifier: null,
  coordinatesToken: null
}, 'PropertyValue') {
  constructor(props) {
    const propMap = ImmutableMap(props || {});
    const timeDelay = propMap.get('timeDelay');
    const identifier = fromJS(propMap.get('identifier'));
    super(propMap.set('timeDelay', timeDelay ? new TimeDelay(timeDelay) : null).set('identifier', identifier ? new FieldDataIdentifier(identifier.toJSON()) : null));
  }
  getType() {
    return this.type;
  }
  setType(type) {
    return this.set('type', type);
  }
  clearValue() {
    return this.merge({
      amount: null,
      propertyName: null,
      timeDelay: null,
      propertyToken: null,
      value: null,
      coordinatesToken: null
    });
  }
  /**
   * Since PropertyValue can take different shapes depending on
   * the `type`, this method will return the "value" based
   * off this `type`.
   *
   * Dropdown values must be unique so we prepend a hash
   * to the field data values to make them unique.
   */
  getValue() {
    const type = this.getType();
    switch (type) {
      case PropertyValueTypes.APPEND_OBJECT_PROPERTY:
      case PropertyValueTypes.OBJECT_PROPERTY:
        // propertyName is correct
        return this.getPropertyName();
      case PropertyValueTypes.ENROLLMENT_EVENT_PROPERTY:
      case PropertyValueTypes.FETCHED_OBJECT_PROPERTY:
      case PropertyValueTypes.ENROLLMENT_DATASET_COLUMN:
        return this.getPropertyToken();
      case PropertyValueTypes.INCREMENT:
        return this.getAmount();
      case PropertyValueTypes.RELATIVE_DATETIME:
        return this.getTimeDelay();
      case PropertyValueTypes.FIELD_DATA:
        {
          const identifier = this.getIdentifier();
          if (identifier) {
            const {
              actionId,
              dataKey
            } = identifier;
            return `__ACTION-${actionId}__${dataKey}`;
          }
          return null;
        }
      case PropertyValueTypes.SINGLE_OBJECT_COORDINATES:
        return this.getCoordinatesToken();
      default:
        return this.value;
    }
  }
  shouldValidate() {
    const type = this.getType();
    switch (type) {
      case PropertyValueTypes.APPEND_OBJECT_PROPERTY:
      case PropertyValueTypes.OBJECT_PROPERTY:
      case PropertyValueTypes.FETCHED_OBJECT_PROPERTY:
      case PropertyValueTypes.ENROLLMENT_EVENT_PROPERTY:
      case PropertyValueTypes.ENROLLMENT_DATASET_COLUMN:
      case PropertyValueTypes.RELATIVE_DATETIME:
      case PropertyValueTypes.FIELD_DATA:
      case PropertyValueTypes.SINGLE_OBJECT_COORDINATES:
        {
          return false;
        }
      default:
        return true;
    }
  }
  getPropertyName() {
    return this.propertyName;
  }
  getTimeDelay() {
    return this.timeDelay;
  }
  getAmount() {
    return this.amount;
  }
  setAmount(amount) {
    return this.set('amount', amount);
  }
  getIdentifier() {
    return this.identifier;
  }
  setValue(value) {
    return this.set('value', value);
  }
  isStaticPropertyValue() {
    return this.getType() === PropertyValueTypes.STATIC_VALUE;
  }
  setPropertyToken(propertyToken) {
    return this.set('propertyToken', propertyToken);
  }
  getPropertyToken() {
    return this.propertyToken;
  }
  getCoordinatesToken() {
    return this.coordinatesToken;
  }
  setCoordinatesToken(coordinatesToken) {
    return this.set('coordinatesToken', coordinatesToken);
  }
}